export const SELECT_ALL = 'select-option-all';
export const ACTION_ICON = 'action-icon' as const;
export const SELECTION_COLUMN_WIDTH = '3%';
export const ACTION_ICON_COLUMN_WIDTH = '3%';
export const EXPANDER_COLUMN_WIDTH = '3%';
